// extracted by mini-css-extract-plugin
export default {"chartLegend":"chartLegend__1TfN3","chartDetail":"chartDetail__yV1wU","legends-color":"legends-color__bhnse"};
    if(module.hot) {
      // 1792681008276
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  